import { matchers } from "../../validate-props";

const reducerName = "formReducer";

export const types = Object.freeze({
    setValid: "SET_VALID",
    setError: "SET_ERROR",
    removeError: "REMOVE_ERROR",
});

export const actions = Object.freeze({
    setValid: (valid) => {
        return { type: types.setValid, valid };
    },
    setError: (error) => {
        return { type: types.setError, error };
    },
    removeError: (errorId) => {
        return { type: types.removeError, errorId };
    },
});

/**
 * Handles boolean states.
 * @param {{
 *   valid: Boolean
 *   errors: {
 *     formFieldId: {
 *       controlId: String,
 *       message: String
 *     }
 *   }
 * }} state
 * @param {{
 *   type: String,
 *   payload: {
 *     valid: Boolean
 *     errors: {
 *       formFieldId: {
 *         controlId: String,
 *         message: String
 *       }
 *     }
 *   }
 *  }} action created by an Action Creator
 * @returns {Boolean}
 */
export const formReducer = (state, action) => {
    //Unexpected state coming
    if (!matchers.object(state)) return state;

    //Unexpected action
    if (!matchers.and(matchers.object(action), action.type in types)) return state;

    //Expected types
    switch (action.type) {
        case types.setValid:
            if (!matchers.boolean(action.valid)) {
                console.warn(`${reducerName}: validity must be of type boolean.`);
                return state;
            }
            state.valid = action.valid;
            return state;

        case types.setError:
            if (!matchers.string(action.error.message)) {
                console.warn(`${reducerName}: error message must be of type string.`);
                return state;
            }
            if (!matchers.string(action.error.id)) {
                console.warn(`${reducerName}: error id must be of type string.`);
                return state;
            }

            state.valid = false;
            state.errors[action.error.id] = { message: action.error.message };
            if (action.error.controlId) {
                state.errors[action.error.id].controlId = action.error.controlId;
            }
            return state;

        case types.removeError:
            if (!matchers.string(action.errorId)) {
                console.warn(`${reducerName}: error id must be of type string`);
                return state;
            }
            delete state.errors[action.errorId];
            return state;

        default:
            return state;
    }
};
